var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"label":_vm.title,"value":_vm.value,"items":_vm.items,"filled":"","hide-details":!_vm.isRequired,"rules":_vm.rules,"clearable":""},on:{"input":function($event){return _vm.$emit('input', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }